import styled from 'styled-components'
import { H1, GridContainer, ContainerHeading, GridSection, Row, Column, ActionLink } from '../../styles/styled-elements'
import styledTheme from '../../styles/theme'

export { H1, GridContainer, ContainerHeading, GridSection, Row, Column, ActionLink, styledTheme }

export const ListHeaderRow = styled(Row)`
  border-bottom: 1px solid ${styledTheme.colors.grid_row_divider};
  font-weight: 500;
  @media (max-width: ${styledTheme.breakpoints.md-1}px) {
    display: none;
  };
`
export const ListRow = styled(Row)`
  border-bottom: 1px solid ${styledTheme.colors.grid_row_divider};
  cursor: pointer;
  &:nth-child(even) {
    background-color: #EDEDED;
  }
  &:last-child {
    border-bottom: none;
  }
`
export const ColumnStyle = {
  padding: '10px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: '0.875rem',
}
export const SmallScreenSiteDataColumnStyle = {
  ...ColumnStyle,
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}
export const SmallScreenSiteDataSiteName = styled.div`
  font-weight: 500;
  font-size: 1.2em;
`
export const SmallScreenSiteDataDetail = styled.div`
  font-size: 0.9em;
`
export const ActionHeaderColumnStyle = {
  ...ColumnStyle,
  justifyContent: 'center'
}
export const ActionColumnStyle = {
  ...ColumnStyle,
  padding: '0',
  justifyContent: 'center',
}
export const ActionColumnStyleRightAligned = {
  ...ColumnStyle,
  padding: '0',
  paddingRight: '10px',
  justifyContent: 'flex-end'
}
export const ActionIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  svg {
    fill: ${styledTheme.colors.action_link};
    height: 30px;
    width: 30px;
  }
  @media (min-width: ${styledTheme.breakpoints.md}px) {
    height: 24px;
    width: 24px;
  };
`
export const ColumnResponsiveInnerContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${styledTheme.breakpoints.md-1}px) {
    min-height: 40px;
    font-size: 1rem;
    font-weight: 500;
  };
`
export const DataViewIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
  svg {
    fill: ${styledTheme.colors.data_view_icon_grey};
    height: 26px;
    width: 26px;
  }
  @media (min-width: ${styledTheme.breakpoints.md}px) {
    height: 20px;
    width: 20px;
  };
`



// WEBPACK FOOTER //
// ./src/containers/sites/styled-elements.js